import React from "react";
import { connect } from 'react-redux';
import ReactDOM from "react-dom";
import { ObtenerReglasMarcasGruposMontajeEnAPI, ActualizarReglasMarcasGruposMontajeEnAPI } from "../../action/actionCreatorsRequests";
import {
    traducirPagina, MSGOK, obtenerUsuario,obtenerToken
} from "../../librerias/funciones"
import FichaMarcasVehiculo from "./FichaMarcasVehiculo.jsx";
import { Select } from 'antd';
import {
    PlusOutlined,
    DeleteOutlined

} from '@ant-design/icons';
const { Option } = Select;

const ReglasFiltroGrupoMontaje = ({ configApp }) => {
    const [alturaSubmenu, setAlturaSubmenu] = React.useState(0);
    const ref = React.useRef(null)


    const [reglasAlmacenes, setReglasAlmacenes] = React.useState([]);
    const [reglasAlmacenesAux, setReglasAlmacenesAux] = React.useState([]);
    const [sociosLocal, setSociosLocal] = React.useState([]);
    const [socioSeleccionado, setSocioSeleccionado] = React.useState(0);
    const [fichaMarcas, setFichaMarcas] = React.useState(false);


    const obtenerReglasAlmacenes = (ORDERCOLUM, ORDERDIR, ID_SOCIO, ID, MARCA, GRUPO_MOTAJE) => {
        setReglasAlmacenes([])
        setReglasAlmacenesAux([])
        ObtenerReglasMarcasGruposMontajeEnAPI(10000, 1, ORDERCOLUM, ORDERDIR, ID_SOCIO, ID, MARCA, GRUPO_MOTAJE).then((reglas) => {
            if (reglas !== undefined) {
                if (reglas.REGISTROS !== null && reglas.REGISTROS.length > 0) {
                    setReglasAlmacenes(reglas.REGISTROS)
                    setReglasAlmacenesAux(reglas.REGISTROS)
                } else {
                    setReglasAlmacenes(null)
                    setReglasAlmacenesAux(null)
                }
            }

        })
    }



    const DarDeBajaUsuario = (payLoadLocal) => {
        const { ID, ID_SOCIO, GM, GM_DESCRIPCION, ID_MARCA } = payLoadLocal;
        ActualizarReglasMarcasGruposMontajeEnAPI(3, ID, ID_SOCIO, ID_MARCA).then(usuario => {
            if (usuario !== undefined) {
                if (usuario.OK) {
                    MSGOK("Regla eliminada correctamente")
                    obtenerReglasAlmacenes(1, "A", socioSeleccionado, "", "", "", "")

                }
            }
        })
    }

    React.useEffect(() => {
        if (ref.current !== null) {
            setAlturaSubmenu(ref.current.clientHeight)
        }
    })

    React.useEffect(() => {
        if (obtenerToken() !== undefined) {
            let accesoLicencia = obtenerUsuario();
            setSociosLocal(accesoLicencia.SOCIOS)

            obtenerReglasAlmacenes(1, "A", accesoLicencia.SOCIOS[0].ID_SOCIO, "", "", "", "")
            setSocioSeleccionado(accesoLicencia.SOCIOS[0].ID_SOCIO)
        }
    }, [])



    document.getElementById("tituloMenu") !== null && ReactDOM.render(
        <>
            {`SERTEC - ${traducirPagina("Filtrado_marcas_grupo").toUpperCase()}`}
        </>,
        document.getElementById("tituloMenu")
    );

    return (
        <>

            <div className="menu_mantenimiento" ref={ref}>
                <div className="mantenimiento_item1" style={{ gap: '10px' }}></div>

                <div className="mantenimiento_item2" style={{ gap: '10px' }}>
                    {sociosLocal !== null ?

                        <Select
                            showSearch
                            allowClear={obtenerUsuario().SOCIOS.length > 1 ? true : false}
                            defaultValue={obtenerUsuario().SOCIOS[0].ID_SOCIO}
                            size={"large"}
                            placeholder={traducirPagina("Seleccione_socio")}
                            style={{ width: "250px", textAlign: 'left' }}
                            optionFilterProp="children"
                            onChange={(e) => {
                                if (e === undefined || e === null) {
                                } else {
                                    setSocioSeleccionado(parseInt(e));
                                    obtenerReglasAlmacenes(1, "A", e, "", "", "", "")
                                }
                            }}
                            filterOption={(input, option) =>
                                option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }
                        >
                            {sociosLocal.length > 0 ?
                                sociosLocal.map((socio) =>
                                    <Option key={socio.ID_SOCIO} value={socio.ID_SOCIO}>{socio.NOMBRE_SOCIO}</Option>
                                )
                                :
                                null
                            }
                        </Select>
                        :
                        <div style={{ textAlign: 'center' }}>
                            <h4>{traducirPagina("Info_error_socio")}</h4>
                        </div>
                    }




                    <div className="botonNuevo" style={{ backgroundColor: 'var(--azul-claro-serca)', color: '#fff' }} onClick={() => {
                        setFichaMarcas(true)
                    }}>
                        <PlusOutlined /> {traducirPagina("Nueva_regla")}
                    </div>
                </div>
            </div>

            <div className="margen_tabla">
                {reglasAlmacenes === null ?
                    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center', minHeight: '80vh' }}>
                        <h4>
                            {traducirPagina("Sin_registros")}
                        </h4>
                    </div>

                    :
                    reglasAlmacenes.length > 0 ?
                        <div className="container_tabla_generico" style={{ height: `calc(100vh - ${(120 + alturaSubmenu)}px )` }} >
                            <table style={{ border: '1px solid #d9d9d9', width: '100%' }}>
                                <thead>
                                    <tr style={{ backgroundColor: '#e0e0e0' }}>
                                        <th style={{ width: '60px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}> {traducirPagina("ID")}  </th>
                                        <th style={{ width: '170px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}  > {traducirPagina("Marca")} </th>
                                        <th style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}  > {traducirPagina("Grupo_montaje")} </th>
                                        <th style={{ width: '50px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }} > </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {reglasAlmacenes.map((regla) =>
                                        <tr key={regla.ID} style={{ backgroundColor: '#fff' }}>
                                            <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }} title={regla.ID}>{regla.ID}</td>
                                            <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }} title={regla.MARCA_DESCRIPCION}>{regla.MARCA_DESCRIPCION}</td>
                                            <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}>{regla.GM_DESCRIPCION}</td>



                                            <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }}>
                                                <div className="flex-container-Grow-Simple">
                                                    <div style={{ margin: '0px 2px' }} >
                                                        <button title={"Dar de baja"} onClick={() => {

                                                            DarDeBajaUsuario(regla)
                                                        }}
                                                            className="btn-matricula  estiloBotonRemove paddindDeTres">
                                                            <DeleteOutlined style={{ cursor: 'pointer', fontSize: '20px', color: '#000' }} />
                                                        </button>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    )
                                    }
                                </tbody>
                            </table>
                        </div>
                        :
                        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center', minHeight: '80vh' }}> <div className="spinner-border  fast colorSubAzul" role="status" disabled /> </div>
                }
            </div>




            {fichaMarcas ?
                <FichaMarcasVehiculo
                    title={traducirPagina("Filtrado_marcas_grupo")}
                    ABRIR_FICHA={fichaMarcas}
                    CERRAR_FICHA={setFichaMarcas}
                    ID_SOCIO={socioSeleccionado}
                    ACTUALIZAR_TABLA={obtenerReglasAlmacenes}
                >
                </FichaMarcasVehiculo>
                :
                null}
        </>
    );
}

const mapStateToProps = state => {
    return {
        search: state.searchValue,
        listaTree: state.listaTree,
        expandedKeys: state.expandedKeys,
        autoExpandParent: state.autoExpandParent,

        configApp: state.configApp,
        buscadorTree: state.buscadorTree,

        pagination: state.pagination,
        grupoDeMarcas: state.grupoDeMarcas,
        colapseMarca: state.colapseMarca,

        fichaBusquedaVehiculo: state.fichaBusquedaVehiculo,
        datosGraficos: state.datosGraficos,
        usuario: state.usuario,
        codmotorizacion: state.codmotorizacion,
        clienteSeleccionado: state.clienteSeleccionado,
        activeItemReferencia: state.activeItemReferencia
    };
}

export default connect(mapStateToProps)(ReglasFiltroGrupoMontaje);







